import {mountClient} from '@slj/ui/client-entry';

import {AdminPage} from '../views/admin';
import {AuditPage} from '../views/audit';
import {DashboardPage} from '../views/dashboard';
import {GroupDetailPage} from '../views/group-detail';
import {GroupsPage} from '../views/groups';
import {JoinPage, JoinRejectedPage} from '../views/join';
import {ForgotPage, ResetPage} from '../views/reset';
import {SecurityPage, SettingsPage} from '../views/settings';
import {SignInPage} from '../views/sign-in';
import {UserAccessPage} from '../views/user-access';

// One entry per SSR'd page — the server embeds the page name in window.__PAGE__.
mountClient({
  'sign-in': SignInPage,
  join: JoinPage,
  'join-rejected': JoinRejectedPage,
  forgot: ForgotPage,
  reset: ResetPage,
  dashboard: DashboardPage,
  settings: SettingsPage,
  security: SecurityPage,
  admin: AdminPage,
  audit: AuditPage,
  groups: GroupsPage,
  'group-detail': GroupDetailPage,
  'user-access': UserAccessPage,
});
